
  <template>
    <div class="flex w-full flex-col ">
      <h3 class="text-base font-bold">Données de rappel</h3>
      <SelectComponent
        v-model="record.send_type"
        name="send_type"
        :label="$t('attributes.send_type')"
        :values="initialMetadata?.enums?.send_types"
        :errors="errors?.send_type"
        display-key="name"
        edition-mode
      />
      <div v-if="error_send_record" class="-mt-3 ml-3 text-xs text-red-600">
        {{ $t('validation.error_send_record') }}
      </div>
      <BaseShowEditTextArea
        v-if="record.send_type"
        v-model="record.remarks"
        name="remarks"
        :label="'notes internes d\'envoi'"
        :edition-mode="true"
        :errors="errors?.remarks"
      />
    </div>
  </template>

<script>
import { defineComponent } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import BaseShowEditTextArea from '@c/addf-package/components/BaseShowEditInput/BaseShowEditTextArea.vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'InvoiceReminderPanel',
  components: {
    BaseShowEditTextArea,
    SelectComponent,
  },
  props: {
    record: {
      type: Object,
      default: null
    },
  },
  emits: ['add-send-record-confirm', 'close'],
  data() {
    return {
      error_send_record: false
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata',
      errors: 'auth/getErrors'
    })
  },
  methods: {
    handleSendRecordConfirm() {
      if (!this.sendRecord.send_type) {
        this.error_send_record = true
      } else {
        this.$emit('add-send-record-confirm')
        this.error_send_record = false
      }
    }
  }
})
</script>
